import { GOOGLE_APP } from 'constants/oAuthKeys';
import * as auth from 'utilities/auth';
import * as extension from 'utilities/extension';
import { getParam } from 'utilities/url';

export const connectGoogleApp = () => {
  auth.openOAuthPopup(GOOGLE_APP, data => {
    let redirectURL;
    const cameFrom = getParam('redirect_after');

    redirectURL = decodeURIComponent(cameFrom);

    if (data.error != null) {
      redirectURL +=
        '?oauth_error=' + data.error + '&provider=' + data.provider;
    } else if (data.provider != null) {
      redirectURL += '?provider=' + data.provider;
    }

    if (data.loginSuccess) {
      extension.signalExtensionLogin(() => {
        window.location.href = redirectURL;
      });
    } else {
      window.location.href = redirectURL;
    }
  });
};
